var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 4.66683H30V2.66683C30 1.93083 29.4027 1.3335 28.6667 1.3335H27.3333C26.5973 1.3335 26 1.93083 26 2.66683V4.66683H14V2.66683C14 1.93083 13.4027 1.3335 12.6667 1.3335H11.3333C10.5973 1.3335 10 1.93083 10 2.66683V4.66683H6.66667C5.194 4.66683 4 5.86083 4 7.3335V11.3335H36V7.3335C36 5.86083 34.806 4.66683 33.3333 4.66683Z",
    fill: "#0496FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 29.3333C14.6667 22.338 20.338 16.6667 27.3333 16.6667C30.69 16.6667 33.7333 17.982 36 20.1133V14H4V32.6667C4 34.1393 5.194 35.3333 6.66667 35.3333H16.1773C15.2147 33.5467 14.6667 31.5047 14.6667 29.3333ZM12.6667 17.3333V23.3333H6.66667V17.3333H12.6667Z",
    fill: "#0496FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3335 19.3335C21.8108 19.3335 17.3335 23.8108 17.3335 29.3335C17.3335 34.8562 21.8108 39.3335 27.3335 39.3335C32.8562 39.3335 37.3335 34.8562 37.3335 29.3335C37.3335 23.8108 32.8562 19.3335 27.3335 19.3335ZM30.3908 34.2762L26.0002 29.8855V22.0002H28.6668V28.7815L32.2762 32.3908L30.3908 34.2762Z",
    fill: "#0496FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.75fb99393b19cb1eb74d4b17f5be08c5.svg";
export { ForwardRef as ReactComponent };